<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.hhxt1">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
        <img
          :src="images.hhxt2"
        >
        <br>
        <br>
        <b style="line-height:1.5;">
          <span style="font-size:18px;font-family:宋体;">混合稀土金属</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          TREM
          99% min
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Ce/Re
          55% min
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          La/Re
          30% min
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        hhxt1: require("../../../assets/img/common/hhxt1.jpg"),
        hhxt2: require("../../../assets/img/common/hhxt2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/hhxt.vue